import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { NavLink, useLocation } from 'react-router-dom';
import { Box, Drawer } from '@mui/material';
import useResponsive from '../../hooks/responsive.hook';
import Logo from '../common/logo.component';
import Scrollbar from '../common/scrollbar.component';
import NavItems from './sidebar/nav-items.component';
import ROUTE_PATH from '../../config/routes.config';
import { APP_THEME } from '../../theme/theme-colors';

const NAV_WIDTH = 280;

const Sidebar = ({ openNav, onCloseNav }) => {
  const { pathname } = useLocation();

  const isDesktop = useResponsive('up', 'lg');

  useEffect(() => {
    if (openNav) {
      onCloseNav();
    }
  }, [pathname]);

  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        '& .simplebar-content': {
          height: 1,
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >
      <Box sx={{ mx: 2, my: 2, display: 'inline-flex' }}>
        <NavLink to={ROUTE_PATH.DASHBOARD} style={{ margin: '0px auto' }}>
          <Logo sx={{ width: 220 }} />
        </NavLink>
      </Box>

      <NavItems />

      <Box sx={{ flexGrow: 1 }} />
    </Scrollbar>
  );

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV_WIDTH },
      }}
    >
      {isDesktop ? (
        <Drawer
          open
          variant="permanent"
          PaperProps={{
            sx: {
              width: NAV_WIDTH,
              bgcolor: APP_THEME,
              borderRightStyle: 'dashed',
            },
          }}
        >
          {renderContent}
        </Drawer>
      ) : (
        <Drawer
          open={openNav}
          onClose={onCloseNav}
          ModalProps={{
            keepMounted: true,
          }}
          PaperProps={{
            sx: {
              width: NAV_WIDTH,
              bgcolor: APP_THEME,
            },
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </Box>
  );
};

Sidebar.propTypes = {
  openNav: PropTypes.bool.isRequired,
  onCloseNav: PropTypes.func.isRequired,
};

export default Sidebar;
